<script setup></script>

<template>
    <ul class="divide-y divide-inherit">
        <slot />
    </ul>
</template>
